import { useWorkoutCardContext } from './workout-card'
import React from 'react'
import { FavoriteSvgIcon } from 'src/component/util/images'
import { useRemoveFavoriteWorkout } from 'src/hook/use-favorite-workouts'

export const WorkoutCardFavoriteRemove = (): React.ReactElement => {
  const { workout } = useWorkoutCardContext()
  const removeFavoriteMutation = useRemoveFavoriteWorkout()

  const handleRemove = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.stopPropagation()
    if (!workout.favoriteId) {
      return
    }

    removeFavoriteMutation.mutate({ id: workout.favoriteId })
  }

  if (!workout.favoriteId) {
    return <></>
  }

  return (
    <button
      onClick={handleRemove}
      className="absolute top-3 right-3 flex items-center justify-center"
      aria-label="Remove from favorites"
    >
      <FavoriteSvgIcon />
    </button>
  )
}
